module.exports = __webpack_public_path__ + "static/media/druta_method.bb676262.png";